import { render, staticRenderFns } from "./IPNs.vue?vue&type=template&id=27a50bca&"
import script from "./IPNs.vue?vue&type=script&lang=js&"
export * from "./IPNs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports